import { render, staticRenderFns } from "./SamplesChart.vue?vue&type=template&id=2a72879e&scoped=true&"
import script from "./SamplesChart.vue?vue&type=script&lang=js&"
export * from "./SamplesChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a72879e",
  null
  
)

export default component.exports